import gql from 'graphql-tag';

export const createCoachMutation = gql`
  mutation createCoach($input: CoachInput!) {
    createCoach(input: $input) {
      coachId
    }
  }
`;
